<template>
  <div>
    <v-layout wrap justify-center class="mobile-layout">
      <v-flex xs4 sm4 md4 lg4 xl4 text-center class="mobile-flex">
        <v-menu offset-y left>
          <template v-slot:activator="{ attrs, on }">
           <v-layout
              style="cursor: pointer"
              wrap
              justify-center
              v-bind="attrs"
              v-on="on"
            >
              <v-flex xs12>
                <v-icon color="#878787" :size="$vuetify.breakpoint.xsOnly ? 20 : 25">
                  mdi-account-circle-outline
                </v-icon>
              </v-flex>
              <v-flex xs12 v-if="!$vuetify.breakpoint.xsOnly" style="line-height: 0.5" pt-1>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #878787;
                  "
                >
                  Account
                </span>
              </v-flex>
            </v-layout>
          </template>
          <v-card tile   flat :elevation="0" max-width="250px" style="z-index:1!important">
            <v-layout wrap justify-start text-left px-4>
              <v-flex pt-4 xs12>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  Welcome
                </span>
              </v-flex>
              <v-flex xs12>
                <span
                  v-if="!appLogin"
                  style="
                    font-family: poppinsmedium;
                    font-size: 13px;
                    color: #1e1b1b;
                  "
                >
                  Sign up as customer
                </span>
              </v-flex>
              <!-- <v-flex pt-2 xs12>
                <v-icon color="#CCB4B4" size="30">
                  mdi-account-circle-outline
                </v-icon>
              </v-flex> -->
              <v-flex xs12>
                <router-link to="/Profile">
                  <span
                    v-if="appLogin"
                    style="
                      font-family: poppinsmedium;
                      font-size: 13px;
                      color: #1e1b1b;
                    "
                  >
                    {{ appUser.firstname }}&nbsp;
                    {{ appUser.lastname }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 pt-4>
                <v-btn
                  v-if="!appLogin"
                  color="#0000001f"
                  outlined
                  rounded
                  @click="userRegister"
                  large
                  small
                  :ripple="false"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 14px;
                      color: #3EA56E;
                    "
                  >
                    LOGIN/SIGNUP
                  </span>
                </v-btn>
                <v-btn
                  v-if="appLogin"
                  color="#0000001f"
                  outlined
                  tile
                  small
                  :ripple="false"
                  @click="appLogout"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 14px;
                      color: #3EA56E;
                    "
                  >
                    LOGOUT
                  </span>
                </v-btn>
              </v-flex>
              <v-flex xs12 py-2 v-if="appLogin">
                <v-layout wrap justify-center>
                  <v-flex xs12 pt-2>
                    <router-link to="/orders?type=Active">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Orders
                      </span>
                    </router-link>
                  </v-flex>
                  <v-flex xs12>
                    <router-link to="/Wishlist">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Wishlist
                      </span>
                    </router-link>
                  </v-flex>
                  <v-flex xs12>
                    <router-link to="/Profile/SavedAddress">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 13px;
                          color: #717171;
                        "
                      >
                        Saved Address
                      </span>
                    </router-link>
                  </v-flex>
                  <v-flex xs12>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 13px;
                        color: #717171;
                      "
                    >
                      Coupons
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs10 py-4 v-if="!appLogin">
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 v-if="!appLogin">
                <v-layout wrap justify-start>
                  <v-flex xs10 lg9>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 13px;
                        color: #717171;
                      "
                    >
                      Get access to KL06
                      <br>
                      <span style="color:#3EA56E"> Bussines account </span>
                    </span>
                  </v-flex>
                  <v-flex xs1 lg1 py-2 pb-6>
                    <v-btn
                      color="#3DA56E"
                      plain
                      class="rounded-circle"
                      :ripple="false"
                      @click="sellerRegister"
                    >
                    <v-icon large color="#3DA56E">mdi-arrow-right-circle-outline</v-icon>
                      <!-- <span
                        style="
                          font-family: poppinssemibold;
                          font-size: 14px;
                          color: #3EA56E;
                        "
                      >
                        LOGIN/SIGNUP
                      </span> -->
                    </v-btn>

                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-menu>
      </v-flex>
        <v-flex xs4 sm4 md4 lg4 xl4 v-if="appType == 'Client'" class="mobile-flex">
          <router-link to="/wishlist">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <v-badge
                  color="#3EA56E"
                  :content="appWishlist ? appWishlist : '0'"
                  right
                  small
                  overlap
                  :offset-y="$vuetify.breakpoint.xsOnly ? '10px' : '15px'"
                  :offset-x="$vuetify.breakpoint.xsOnly ? '10px' : '15px'"
                >
                  <v-icon color="#878787" :size="$vuetify.breakpoint.xsOnly ? 20 : 25">mdi-bookmark-outline</v-icon>
                </v-badge>
              </v-flex>
              <v-flex xs12 v-if="!$vuetify.breakpoint.xsOnly" style="line-height: 0.5" pt-1>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #878787;
                  "
                >
                  Wishlist
                </span>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
        <v-flex xs4 sm4 md4 lg4 xl4 v-if="appType == 'Client'" class="mobile-flex">
          <router-link to="/Cart">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <v-badge
                  color="#3EA56E"
                  :content="appCart ? appCart : '0'"
                  right
                  small
                  overlap
                  :offset-y="$vuetify.breakpoint.xsOnly ? '10px' : '15px'"
                  :offset-x="$vuetify.breakpoint.xsOnly ? '10px' : '15px'"
                >
                  <v-icon color="#878787" :size="$vuetify.breakpoint.xsOnly ? 20 : 25">mdi-cart-outline</v-icon>
                </v-badge>
              </v-flex>
              <v-flex xs12 v-if="!$vuetify.breakpoint.xsOnly" style="line-height: 0.5" pt-1>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #878787;
                  "
                >
                  Cart
                </span>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appCart() {
      if (this.$store.state.cartItems == undefined) {
        return 0;
      } else {
        return this.$store.state.cartItems;
      }
    },
    appWishlist() {
      if (this.$store.state.wishlistItems == undefined) {
        return 0;
      } else {
        return this.$store.state.wishlistItems;
      }
    },
    appUser() {
      return this.$store.state.userData;
    },
    appType() {
      return this.$store.state.userType;
    },
  },

  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    sellerRegister() {
      localStorage.setItem("regType", "Seller");
      this.$router.push("/Login");
    },
    userRegister() {
      localStorage.setItem("regType", "Client");
      this.$router.push("/Login");
    },
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  ::v-deep .v-badge__badge {
    font-size: 8px !important;
    height: 14px !important;
    min-width: 14px !important;
    padding: 2px !important;
    line-height: 10px !important;
  }
  .mobile-flex {
    flex-basis: auto !important;
    max-width: none !important;
    padding: 0 8px !important;
  }
  .mobile-layout {
    justify-content: flex-end !important;
  }
}
</style>